import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { isEmpty, pick } from 'lodash-es'
import { getQuery } from '@vt/utils'
import {
  // useCustomInfoSWR,
  fetchLoginCode as loginCodeApi,
  loginByCode as loginTelCodeApi,
  userRegister as userRegisterApi,
  checkUserIsExist as userExistApi,
  // getInformationStorage as getInformationStorageApi,
  loginByTel as loginByTelApi,
  loginByLoginName as loginByLoginNameApi,
  loginByTelDygc as loginByTelDygcApi,
  loginByLoginNameDygc as loginByLoginNameDygcApi,
  loginByDD as loginByDDApi,
} from '@vt/apis/lib-ex/v2/login'
// import { routeTo } from '@vt/utils'
import { transformAppId, newLoginTypeTpls } from '@vt/apis/lib-ex'
// import useStorage from '../storages/use-storage'
import useProjectStore from '../project/use-project-store'
// import useRouteTo from '../navigation/use-route-to'

// import authContext from './context'

// 调研工厂的登录只验证11位
const phoneReg = /^\d{11}$/
// 长度6-16位，至少包含数字、字母或符号中的两种
const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,16}$/

// 判断环境
// const DEP_ENV = process.env.REACT_APP_DEP
export default function useLogin() {
  // const isDev = _key.indexOf('$') >= 0
  // const key = _key.replace('$', '')
  // const navigate = useNavigate()
  const {
    customInfo,
    isDebug,
    cusKey: key,
    setToken,
  } = useProjectStore((s) =>
    pick(s, ['setToken', 'cusKey', 'isDebug', 'customInfo'])
  )
  // const { routeTo } = useRouteTo()
  // console.log(customInfo, isDebug, key)
  // const { setToken } = getStore((s) => {
  //   pick(s, ['setToken', 'setUserInfo'])
  // })
  // const { setToken } = getStore() || {}

  const setDefaultValues = () => {
    if (!isDebug) {
      return {}
    }

    if (key === 'lhzf') {
      return {
        userName: 'qqq@20138',
        password: 'qqq123123',
      }
    }
    if (key === 'ugm') {
      return {
        userName: '15910690458',
        password: 'zz123456',
      }
    }
    if (key === 'ydspxj') {
      return {
        userName: '1761@20145',
        password: 'qqq123123',
      }
    }
    if (key === 'yyzcjc') {
      return {
        userName: '15531457745@20139',
        password: 'qqq123123',
      }
    }
    if (key === 'zrzh') {
      return {
        userName: '13287268573@20141',
        password: 'qqq123123',
      }
    }

    return {}
  }
  // const { setExtras } = useStorage()

  // const { afterLogin } = useContext(authContext)
  const {
    trigger,
    register,
    unregister,
    control,
    reset,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    reValidateMode: 'onChange',
    shouldUseNativeValidation: false,
    defaultValues: setDefaultValues(),
  })

  const { code } = getQuery()
  const [loginType, setLoginType] = useState(code ? 'dingding' : 'password')
  // 通过key 获取定制信息
  // const { customInfo } = useCustomInfoSWR(key)

  // 数据获取
  const getUsername = () => {
    return getValues('userName')
  }

  const getPassword = () => {
    return getValues('password')
  }

  const getRePassword = () => {
    return getValues('rePassword')
  }

  const getCode = () => {
    return getValues('code')
  }

  const clearAllValues = () => {
    reset()
  }

  // 设置错误信息
  const setUsernameError = (msg) => {
    if (msg) {
      setError('userName', {
        message: msg,
      })
    } else {
      clearErrors('userName')
    }
  }

  const setPasswordError = (msg) => {
    if (msg) {
      setError('password', {
        message: msg,
      })
    } else {
      clearErrors('password')
    }
  }

  const setRePasswordError = (msg) => {
    if (msg) {
      setError('rePassword', {
        message: msg,
      })
    } else {
      clearErrors('rePassword')
    }
  }

  const setCodeError = (msg) => {
    if (msg) {
      setError('code', {
        message: msg,
      })
    } else {
      clearErrors('code')
    }
  }

  const clearAllErrors = () => {
    setUsernameError(null)
    setPasswordError(null)
    setRePasswordError(null)
    setCodeError(null)
  }

  // 手动校验相关
  const validationUsername = (value, isUseReg) => {
    if (
      loginType === 'password' &&
      !phoneReg.test(value) &&
      value.indexOf('@') === -1 &&
      !newLoginTypeTpls.includes(key) // fix秋羽，为什么加这个呢判断呢
      // key !== 'zrzh' &&
      // key !== 'nydl' &&
      // key !== 'cyhjjc'
    ) {
      setUsernameError(
        loginType === 'password' && !isUseReg
          ? '用户名格式不正确'
          : '手机号格式不正确'
      )
    } else if (
      loginType !== 'password' &&
      !phoneReg.test(value) &&
      !newLoginTypeTpls.includes(key)
      // key !== 'zrzh' &&
      // key !== 'nydl' &&
      // key !== 'cyhjjc'
    ) {
      setUsernameError('手机号格式不正确')
    } else {
      setUsernameError(null)
    }
  }

  const validationPassword = (value, isUseReg) => {
    if (isUseReg && !pwdReg.test(value)) {
      setPasswordError('长度6-16位，至少包含数字、字母或符号中的两种')
    } else {
      setPasswordError(null)
    }
  }

  // 注册
  const registerUserName = () => {
    const { onChange } = register('userName')
    return {
      ...register('userName'),
      placeholder:
        loginType === 'password'
          ? '请输入手机号或带@id的用户名'
          : '请输入手机号',
      onChange: (e) => {
        onChange(e)
        const { value } = e.target
        validationUsername(value)
      },
    }
  }

  // 重复校验密码
  const validateRePassword = () => {
    if (getPassword() !== getRePassword()) {
      setError('rePassword', {
        message: '两次密码不一致',
      })
    } else {
      setRePasswordError(null)
      clearErrors('rePassword')
    }
  }

  const registerPassword = (isUseReg) => {
    const { onChange } = register('password')
    return {
      ...register('password'),
      onChange: (e) => {
        const { value } = e.target
        onChange(e)
        validationPassword(value, isUseReg)
        if (getRePassword(e)) {
          validateRePassword()
        }
      },
    }
  }

  const registerRePassword = () => {
    const { onChange } = register('rePassword')
    return {
      ...register('rePassword'),
      onChange: (e) => {
        onChange(e)
        validateRePassword()
      },
    }
  }

  const registerCode = () => {
    const { onChange } = register('code')
    return {
      ...register('code'),
      onChange: (e) => {
        onChange(e)
        setCodeError(null)
      },
    }
  }

  // 判断登录按钮是否可以点击
  const checkLoginDisabled = () => {
    const data = getValues()
    if (!isEmpty(errors)) {
      return true
    }
    if (loginType === 'password') {
      if (
        data.userName &&
        data.password &&
        data.userName !== '' &&
        data.password !== ''
      ) {
        return false
      }
      return true
    }
    if (
      data.userName &&
      data.code &&
      data.userName !== '' &&
      data.code !== ''
    ) {
      return false
    }
    return true
  }

  // 判断注册按钮是否可以点击
  const checkRegisterDisabled = () => {
    const data = getValues()
    if (!isEmpty(errors)) {
      return true
    }
    if (
      data.userName &&
      data.password &&
      data.rePassword &&
      data.code &&
      data.userName !== '' &&
      data.password !== '' &&
      data.rePassword !== '' &&
      data.code !== ''
    ) {
      return false
    }
    return true
  }

  // 切换登录方式
  const onChangeLoginType = (type) => {
    if (type === 'dingding') {
      setLoginType('dingding')
      unregister('password')
      unregister('code')
    } else if (loginType === 'password') {
      setLoginType('code')
      unregister('password')
    } else {
      setLoginType('password')
      unregister('code')
    }
  }

  // 接口
  // 获取验证码
  const getLoginCode = (type) => {
    if (!getUsername()) {
      setUsernameError('请输入手机号')
    } else if (errors.userName) {
      setUsernameError('请输入正确的手机号')
    }
    return loginCodeApi(getUsername(), type)
  }

  // 存储token
  const saveToken = (token) => {
    setToken(token)
  }

  const dataDeal = (res, loginCallback, errorCallBack) => {
    let data = res
    try {
      data = JSON.parse(res)
    } catch (e) {
      console.log(data)
    }
    if (data && typeof data !== 'string' && data.status !== 200) {
      if (data.message) {
        errorCallBack(data.message)
      }
    } else {
      saveToken(res)
      if (loginCallback) {
        loginCallback(res)
      }
      // 这里的应该在 callback 处理
      console.log('login->>', transformAppId[key])
    }
  }

  // 通过用户名密码登录
  const loginByLoginName = async (loginCallback) => {
    // 因为新上的【人员管理】相关接口暂时适用于移动视频巡检项目，所以单独处理
    if (key === 'ydspxj') {
      const res = await loginByLoginNameApi(getUsername(), getPassword())
      dataDeal(res, loginCallback, (message) => {
        setPasswordError(message)
        loginCallback(res)
      })
    } else {
      const res = await loginByLoginNameDygcApi(getUsername(), getPassword())
      dataDeal(res, loginCallback, (message) => {
        setPasswordError(message)
        loginCallback(res)
      })
    }
  }

  // 通过手机号登录
  const loginByTel = async (loginCallback) => {
    // 因为新上的【人员管理】相关接口暂时适用于移动视频巡检项目，所以单独处理
    if (key === 'ydspxj') {
      const res = await loginByTelApi(getUsername(), getPassword())
      dataDeal(res, loginCallback, (message) => {
        setPasswordError(message)
      })
    } else {
      const res = await loginByTelDygcApi(getUsername(), getPassword())
      dataDeal(res, loginCallback, (message) => {
        setPasswordError(message)
      })
    }
  }

  // 登录
  const onUserLogin = async (loginCallback) => {
    clearAllErrors()
    if (!checkLoginDisabled()) {
      const username = getUsername()
      // TODO-SDH: 抽取成三个方法, 而且 error 的处理很冗余, 应该抽取一个当登录失败时的通用方法
      if (loginType === 'password') {
        // 内蒙古项目，暂时只支持用户名密码登录
        if (newLoginTypeTpls.includes(key) || !key) {
          // if (key === 'zrzh' || key === 'cyhjjc' || key === 'nydl') {
          const res = await loginByLoginNameApi(
            getUsername(),
            getPassword()
          ).catch((err) => {
            return err.data || err
          })

          dataDeal(res, loginCallback, (message) => {
            setPasswordError(message)
            loginCallback(res)
          })
        } else if (username.indexOf('@') > -1) {
          // 通过账号密码登录
          loginByLoginName(loginCallback)
        } else {
          // 通过手机号登录
          loginByTel(loginCallback)
        }
      } else {
        // 通过验证码登录
        loginTelCodeApi(getUsername(), getCode()).then((res) => {
          dataDeal(res, loginCallback, (message) => {
            setCodeError(message)
          })
        })
      }
    }
  }

  const onDDLogin = async (_code, source, loginCallback, errorCallBack) => {
    const res = await loginByDDApi(_code, source).catch((err) => {
      return err.data || err
    })
    dataDeal(res, loginCallback, (msg) => {
      errorCallBack(msg)
    })
  }

  // 回车登录
  const inputOnKeyDown = (e, loginCallBack) => {
    if (e.key === 'Enter') {
      onUserLogin(loginCallBack)
    }
  }

  // 注册
  const afterRegister = (registerCallback) => {
    if (!checkRegisterDisabled()) {
      userExistApi(getUsername()).then((res) => {
        const { exist } = res
        if (exist) {
          setUsernameError('用户名已存在')
        } else {
          userRegisterApi({
            username: getUsername(),
            password: getPassword(),
            code: getCode(),
          }).then((data) => {
            const { token } = data
            if (!data.success) {
              if (data.usernameMessage) {
                setUsernameError(data.usernameMessage)
              }
              if (data.codeMessage) {
                setCodeError(data.codeMessage)
              }
              if (data.passwordMessage) {
                setPasswordError(data.passwordMessage)
              }
            } else if (registerCallback) {
              registerCallback(token)
            }
          })
        }
      })
    }
  }
  // useEffect(() => {
  //   // 将定制信息存储
  //   if (customInfo && !isEmpty(customInfo)) {
  //     setExtras('customInfo', customInfo)
  //   }
  // }, [customInfo])

  return {
    // 接口
    customInfo,
    getLoginCode,
    // 登录类型
    loginType,
    onChangeLoginType,
    // 表单相关
    trigger,
    control,
    errors,
    getUsername,
    getPassword,
    clearAllValues,
    codeBtnDisabled: !(getUsername() && !errors.userName),
    passwordOk: getPassword() && !errors.password,
    rePasswordOk: getRePassword() && !errors.rePassword,
    usernameOk: getUsername() && !errors.userName,
    registerUserName,
    registerPassword,
    registerRePassword,
    registerCode,
    validationUsername,
    validationPassword,
    validateRePassword,
    // 登录、注册
    onUserLogin,
    onDDLogin,
    inputOnKeyDown,
    afterRegister,
    // redirectPage,
    // 单点登录
    saveToken,
    clearAllErrors,
  }
}
